import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { Desktop, Mobile } from '../../../App';
import { H3, H4, P1, P2, P3 } from '../../../styles/FontStyles';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { Hub } from '../Hub/Hub';

import { useDispatch } from 'react-redux';
import { Checkbox } from '../Checkbox/Checkbox';

import { VirtualOfficeSubscriptionStyled } from './VirtualOfficeSubscription.styled';

import {
  BACKOFFICE_NAME_CAPS,
  CLUB,
  formatUSD,
  USDT
} from '../../../helpers/helperFunctions';

import { addHub } from '../../../views/Marketplace/Marketplace.actions';

import { useAppSelector } from '../../../app/hooks';
import { buyVirtualOffice } from '../../../views/Settings/Settings.actions';

interface VirtualOfficeSelectedPlanProps {
  step: number;
  setStep: Dispatch<SetStateAction<number>>;
  selected: any;
  selectedHub?: number;
}

export const VirtualOfficeSelectedPlan = ({
  step,
  setStep,
  selected,
  selectedHub
}: VirtualOfficeSelectedPlanProps) => {
  const dispatch = useDispatch();
  const { user } = useAppSelector((state) => state.auth.userInfo);
  const { hubs } = useAppSelector((state) => state.marketplace);

  const hub = hubs?.find((i) => i.id === selectedHub);

  const { t } = useTranslation('marketplace');

  return (
    <div>
      {!selectedHub && (
        <>
          <P1 bold mb={'20'}>
            {t('selected_subscription', { BACKOFFICE_NAME_CAPS })}
          </P1>
          <VirtualOfficeSubscriptionStyled>
            <Desktop>
              <div>
                <Flexed between center>
                  <Flexed center>
                    <Checkbox margin='0 12px 0 0' size={'38'} checked={true} />
                    <div>
                      <P1 caps bold>
                        {selected.title}
                      </P1>
                    </div>
                  </Flexed>
                  <div style={{ textAlign: 'end' }}>
                    <H3>${selected.price}</H3>
                  </div>
                </Flexed>
              </div>
            </Desktop>
            <Mobile>
              <div>
                <Flexed between center>
                  <Flexed center>
                    <Checkbox margin='0 12px 0 0' size={'38'} checked={true} />
                    <div>
                      <H4>{selected.title}</H4>
                    </div>
                  </Flexed>
                  <div style={{ textAlign: 'end' }}>
                    <H4>${selected.price}</H4>
                  </div>
                </Flexed>
              </div>
            </Mobile>
          </VirtualOfficeSubscriptionStyled>
        </>
      )}
      {selectedHub && (
        <P2 mb={'20'} bold>
          {t('selected_staking_hub_nft')}:
        </P2>
      )}

      {selectedHub &&
        hubs.map(
          ({
            id,
            image,
            title,
            price,
            weeklyCap,
            dobuleTradingBinaries,
            limitedQuantity
          }) => {
            if (id === selectedHub) {
              return (
                <Hub
                  key={id}
                  condensed
                  image={image}
                  title={title}
                  price={hub!.price ? price + selected.price : price}
                  weeklyCap={weeklyCap}
                  dobuleTradingBinaries={dobuleTradingBinaries}
                  includesSubscription={selected.access}
                  limitedQuantity={limitedQuantity}
                />
              );
            } else return null;
          }
        )}

      <P3 mb='10' mt='40' center>
        {CLUB} {t('backoffice_balance')}:{' '}
        <b>
          {formatUSD(user?.userTickets?.shoppingPoints)} {USDT}
        </b>
      </P3>

      <Button
        mb={20}
        onClick={() => {
          if (selectedHub) {
            dispatch(
              addHub({
                packageId: selectedHub,
                currencyType: 2,
                networkType: null,
                licenceId: selected.id,
                userDiscountCodeId: null,
                step: 3,
                setStep
              })
            );
          } else {
            dispatch(
              buyVirtualOffice({
                licenceId: selected.id,
                networkType: null,
                currencyType: 2,
                step: 5,
                setStep
              })
            );
          }
        }}
        disabled={
          user?.userTickets?.shoppingPoints === 0 ||
          selected.price > user?.userTickets?.shoppingPoints
        }>
        {t('pay_with_club_balance')}
      </Button>

      <P3 mb='10' center>
        {USDT} {t('backoffice_balance')}:{' '}
        <b>
          {formatUSD(user?.userTickets?.availableRewardPoints)} {USDT}
        </b>
      </P3>

      <Button
        mb={20}
        onClick={() => {
          if (selectedHub) {
            dispatch(
              addHub({
                packageId: selectedHub,
                currencyType: 3,
                networkType: null,
                licenceId: selected.id,
                userDiscountCodeId: null,
                step: 3,
                setStep
              })
            );
          } else {
            dispatch(
              buyVirtualOffice({
                licenceId: selected.id,
                networkType: null,
                currencyType: 3,
                step: 5,
                setStep
              })
            );
          }
        }}
        disabled={
          user?.userTickets?.availableRewardPoints === 0 ||
          selected.price > user?.userTickets?.availableRewardPoints
        }>
        {t('pay_with_usdt_balance')}
      </Button>

      <Button negative mb={20} onClick={() => setStep(step)}>
        {t('pay_with_tether')}
      </Button>
    </div>
  );
};
